module.exports = __webpack_public_path__ + "img/Teamfoto.b56ccd0c.jpg";